import { Component, OnInit } from "@angular/core";
import { loadingRequest } from "src/app/services/appconst";
import {
  FundRaiserServiceService,
  IFundRaiserProjectData,
} from "src/app/services/fund-raiser-service.service";
import { GeneralserviceService } from "src/app/services/generalservice.service";

@Component({
  selector: "app-dashboard-top-fundraisers-cards",
  templateUrl: "./dashboard-top-fundraisers-cards.component.html",
  styleUrls: ["./dashboard-top-fundraisers-cards.component.scss"],
})
export class DashboardTopFundraisersCardsComponent implements OnInit {
  topFundRaiser: IFundRaiserProjectData[] = [];

  loadingStateData = loadingRequest; // Get the Loading State Date from the Loading Request Enum
  loadingstate = loadingRequest.loading; // Set the Initial State to Loading

  constructor(
    public generalService: GeneralserviceService,
    public fundRaiseService: FundRaiserServiceService
  ) {}

  ngOnInit() {
    this.loadTopFundRaiser();
  }

  async loadTopFundRaiser() {
    this.loadingstate = loadingRequest.loading;

    await this.fundRaiseService.authservice.onLoad();

    await this.fundRaiseService
     .getFundRaiserExplore({ active: true, perpage: 6, isPrivate: false })
      .subscribe(
        (res) => {
          if (!res.meta.total) {
            this.loadingstate = loadingRequest.noData;
          } else if (res.meta.total) {
            this.loadingstate = loadingRequest.success;
            this.topFundRaiser = res.data;
            // console.log(res);
            this.loadingstate = loadingRequest.success;
          }
        },
        (err) => {
          this.loadingstate = loadingRequest.error;
          // console.log(err);
        }
      )
      .add(() => {});
  }
}
